const convertAddress = (data) => {
  let dataAddress = "";
  if (data.rtrw) {
    dataAddress =
      data.address +
      ", " +
      data.rtrw +
      ", " +
      data.village +
      ", " +
      data.city +
      ", " +
      data.province;
  } else if (data.subdistrict) {
    dataAddress =
      data.address +
      ", " +
      data.village +
      ", " +
      data.subdistrict +
      ", " +
      data.city +
      ", " +
      data.province;
  } else {
    dataAddress = data.address;
  }
  return dataAddress;
};

export default convertAddress;
